<template>
  <DataDrivenTransition :is-next="next">
    <template #default>
      <div
        v-if="active"
        :key="fieldId"
        class=""
      >
        <slot />
      </div>
    </template>
  </DataDrivenTransition>
</template>

<script setup>
  import { computed, watch } from 'vue'
  import DataDrivenTransition from '../transitions/dataDrivenTransitions'

  const props = defineProps({
    fieldId: {
      type: String,
      required: true
    },
    activeField: {
      type: String,
      default: null
    },
    next: {
      type: Boolean,
      default: true
    }
  })
  const active = computed(() => {
    return props.activeField === props.fieldId
  })
</script>
